import React, { useState, useEffect } from "react";
import { FiMessageSquare } from "react-icons/fi";
import { motion, AnimatePresence } from "framer-motion";
import Button from "../../../../../app/components/Button";
import FormDeleteTemplate from "../../../../../forms/FormsEmail/FormDeleteTemplate";

const Templates = ({ setCount }) => {
  const [templates, setTemplates] = useState([
    {
      id: 1,
      date: "27/05/2025, 20:49:53",
      title: "Ordem de serviço concluída",
      subject: "✅ Ordem de Serviço concluída com sucesso",
      content:
        "A Ordem de Serviço #{{Ordem de Serviço}} foi concluída com sucesso. O problema identificado foi: {{Problema}}, com a seguinte solicitação: {{Descrição da solicitação}}. Após análise e execução, entregamos a solução conforme descrito: {{Descrição do que foi entregue}}.",
    },
    {
      id: 2,
      date: "",
      title: "Atualização de produto",
      subject: "Resumo da última atualização do produto.",
      content: "Olá, lançamos novas funcionalidades. Veja o detalhamento completo...",
    },
    {
      id: 3,
      date: "",
      title: "Lembrete de pagamento",
      subject: "Um lembrete amigável sobre seu pagamento.",
      content: "Olá, seu pagamento vence dia 10. Por favor, confirme o pagamento...",
    },
  ]);

  const [expandedId, setExpandedId] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedTemplate, setSelectedTemplate] = useState(null);

  useEffect(() => {
    setCount(templates.length);
  }, [templates, setCount]);

  const toggleExpand = (id) => {
    setExpandedId(expandedId === id ? null : id);
  };

  const handleOpenDeleteModal = (template) => {
    setSelectedTemplate(template);
    setIsModalOpen(true);
  };

  const handleConfirmDelete = (idToDelete) => {
    setTemplates((prev) => prev.filter((template) => template.id !== idToDelete));
    setIsModalOpen(false);
    if (expandedId === idToDelete) {
      setExpandedId(null);
    }
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedTemplate(null);
  };

  return (
    <div>
      {templates.length > 0 ? (
        templates.map(({ id, title, subject, content, date }) => (
          <div
            key={id}
            className="border rounded-tl-2xl rounded-tr-2xl rounded-br-2xl overflow-hidden mb-4"
          >
            <div
              className="flex items-center transition-colors duration-300 ease-in-out hover:bg-gray-50 pl-2 cursor-pointer"
              onClick={() => toggleExpand(id)}
            >
              <FiMessageSquare className="mt-[.2rem]" color="#3f1057" />
              <button className="w-full text-left px-2 py-3 font-medium text-[#3f1057] focus:outline-none">
                {title}
              </button>
            </div>

            <AnimatePresence>
              {expandedId === id && (
                <motion.div
                  initial={{ opacity: 0, height: 0 }}
                  animate={{ opacity: 1, height: "auto" }}
                  exit={{ opacity: 0, height: 0 }}
                  transition={{ duration: 0.3, ease: "easeInOut" }}
                  className="p-4 bg-white text-gray-800 border-l-4 border-purple-700 overflow-hidden"
                >
                  <h1 className="mb-2">
                    <span className="font-semibold">Assunto:</span> {subject}
                  </h1>
                  <p className="mb-2">{content}</p>
                  {date && (
                    <p className="font-semibold text-sm text-gray-500">{date}</p>
                  )}
                  <Button
                    variant="secondary"
                    className="mt-4"
                    onClick={() => handleOpenDeleteModal({ id, title })}
                  >
                    Excluir
                  </Button>
                </motion.div>
              )}
            </AnimatePresence>
          </div>
        ))
      ) : (
        <div className="text-center text-gray-500 py-8">
          Nenhum template cadastrado.
        </div>
      )}

      <FormDeleteTemplate
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        onConfirm={handleConfirmDelete}
        template={selectedTemplate}
      />
    </div>
  );
};

export default Templates;
